import Svg, {Path, type PathProps, type SvgProps} from 'react-native-svg'

import {usePalette} from '#/lib/hooks/usePalette'

const ratio = 17 / 64

export function Logotype({
  fill,
  ...rest
}: {fill?: PathProps['fill']} & SvgProps) {
  const pal = usePalette('default')
  // @ts-ignore it's fiiiiine
  const size = parseInt(rest.width || 32)

  return (
    <Svg
      fill="none"
      viewBox="0 0 500 305"
      {...rest}
      width={size}
      height={Number(size) * ratio}>
      <Path
        fill={fill || pal.text.color}
        d="M90.98,202.79c4.69,2.93,12.89,6.1,20.65,6.1,11.38,0,16.65-5.59,16.65-12.76s-4.53-11.42-15.92-15.69c-15.48-5.6-22.81-14.03-22.77-24.29,0-13.8,11.21-25.12,29.64-25.12,8.72,0,16.22,2.36,20.98,5.27l-3.87,11.33c-3.3-2.07-9.57-5.04-17.57-5.04-9.19,0-14.19,5.3-14.19,11.76,0,7.09,5.04,10.25,16.27,14.61,14.77,5.5,22.44,12.95,22.48,25.74,0,15.18-11.8,25.81-32.04,25.81-9.38,0-18.05-2.43-24.08-5.97l3.78-11.75Z"
      />
      <Path
        fill={fill || pal.text.color}
        d="M178.8,172.27h.35c2.09-3.01,5.03-6.81,7.48-9.76l25.25-29.53h18.71l-33.08,35.23,37.72,50.44h-18.99l-29.47-41.17-7.97,8.92v32.25h-15.49v-125.78h15.49v79.39Z"
      />
      <Path
        fill={fill || pal.text.color}
        d="M254.35,132.98l18.72,50.64c2.01,5.66,4.11,12.38,5.51,17.48h.43c1.53-5.04,3.42-11.61,5.47-17.83l16.95-50.29h16.53l-23.44,61.03c-11.1,29.46-18.73,44.45-29.34,53.73-7.7,6.66-15.3,9.31-19.1,10l-3.87-13.02c3.91-1.23,8.98-3.67,13.65-7.61,4.2-3.4,9.41-9.44,13.03-17.35.79-1.64,1.21-2.79,1.21-3.76,0-.88-.25-2.11-1.09-4l-31.59-79.02h16.94Z"
      />
      <Path
        fill={fill || pal.text.color}
        d="M412.8,116.02c0,4.48-3.63,8.12-8.12,8.12-1.09,0-2.14-.22-3.09-.61-1.12,1.18-2.7,1.91-4.45,1.91-1.4,0-2.69-.47-3.72-1.26-.73.23-1.51.35-2.31.35-4.29,0-7.76-3.47-7.76-7.76,0-4.07,3.13-7.4,7.11-7.73.7-2.62,3.09-4.55,5.93-4.55,2.58,0,4.78,1.59,5.7,3.83.81-.28,1.68-.43,2.59-.43,4.49,0,8.12,3.64,8.12,8.12Z"
      />
      <polygon
        fill={fill || pal.text.color}
        points="390.32 132.98 390.32 144.79 390.32 218.65 405.82 218.65 405.82 132.98 390.32 132.98"
      />
      <Path
        fill={fill || pal.text.color}
        d="M371.11,90.93c-24.11,0-37.43,14.75-37.43,37.3v4.75h-11.96v11.8h11.96v73.87h15.5v-73.87h34.27v-11.8h-34.35v-4.25c0-13.75,4.88-25.28,21.32-25.28,4.48,0,6.87.28,10.3,1.48l4.68-11.77c-4.37-1.37-9.55-2.24-14.29-2.24Z"
      />
    </Svg>
  )
}
